import { Button, Grid, IconButton } from '@material-ui/core'
import { Add, Cancel } from '@material-ui/icons'
import { FieldArray, Formik } from 'formik'
import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { inviteProjectContributors } from '../../../actions/projectActions'
import TextInput from '../../Form/TextInput'
import Message from '../../Message/Message'

const ContributorAdd = ({ setShowAddContributorModal }) => {
  const dispatch = useDispatch()
  const formRef = useRef(null)

  const { loading, error } = useSelector(
    (state) => state.projectAddContributors
  )

  const handleAddAnotherClick = () => {
    const newUser = { firstName: '', lastName: '', email: '' }
    const users = [...formRef.current.values.users, newUser]

    formRef.current.setFieldValue('users', users)
  }

  const handleRemoveClick = (index) => {
    const users = [...formRef.current.values.users]

    if (users.length === 1) {
      users[0] = { firstName: '', lastName: '', email: '' }
    } else {
      users.splice(index, 1)
    }

    formRef.current.setFieldValue('users', users)
  }

  const handleSubmit = () => {
    const users = [...formRef.current.values.users]

    dispatch(inviteProjectContributors(users))
  }

  return (
    <>
      <h4 className="m-b-32">Send invitation(s)</h4>

      <Formik
        innerRef={formRef}
        validateOnChange={false}
        initialValues={{
          users: [{ firstName: '', lastName: '', email: '' }],
        }}
        validate={(values) => {
          let errors = { users: [] }
          let usersErrors = []

          values.users.forEach((user, index) => {
            let userErrors = {}

            const isDuplicateEmail = values.users.some(
              (j, i) => j.email === user.email && index !== i
            )

            if (isDuplicateEmail) {
              userErrors.email = 'Email must be unique.'
            }

            if (!user.firstName) {
              userErrors.firstName = 'This is a required field'
            }

            if (!user.lastName) {
              userErrors.lastName = 'This is a required field'
            }

            if (!user.email) {
              userErrors.email = 'This is a required field'
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user.email)
            ) {
              userErrors.email = 'Invalid email address'
            }

            if (Object.keys(userErrors).length !== 0) {
              usersErrors[index] = userErrors
            }
          })

          if (usersErrors.length) {
            errors = { ...errors, users: usersErrors }
            return errors
          }
        }}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <div style={{ overflowY: 'auto', maxHeight: 363, height: 363 }}>
              <FieldArray
                name="users"
                render={() =>
                  formik.values.users.map((user, index) => (
                    <div key={index} className="flex relative">
                      <Grid
                        key={index}
                        container
                        spacing={4}
                        className="relative p-r-60"
                      >
                        <Grid item sm={4}>
                          <TextInput
                            name={`users[${index}].firstName`}
                            label="First name"
                            variant="outlined"
                            value={user.firstName}
                            onChange={formik.handleChange}
                            error={
                              formik.errors.users && formik.errors.users[index]
                                ? formik.errors.users[index].firstName
                                : undefined
                            }
                          />
                        </Grid>
                        <Grid item sm={4}>
                          <TextInput
                            name={`users[${index}].lastName`}
                            label="Last name"
                            variant="outlined"
                            value={user.lastName}
                            onChange={formik.handleChange}
                            error={
                              formik.errors.users && formik.errors.users[index]
                                ? formik.errors.users[index].lastName
                                : undefined
                            }
                          />
                        </Grid>
                        <Grid item sm={4}>
                          <TextInput
                            name={`users[${index}].email`}
                            label="Email"
                            variant="outlined"
                            value={user.email}
                            onChange={formik.handleChange}
                            error={
                              formik.errors.users && formik.errors.users[index]
                                ? formik.errors.users[index].email
                                : undefined
                            }
                          />
                        </Grid>
                      </Grid>

                      <IconButton
                        style={{
                          position: 'absolute',
                          right: 0,
                          top: 30,
                        }}
                        onClick={() => handleRemoveClick(index)}
                        className="p-8"
                      >
                        <Cancel />
                      </IconButton>
                    </div>
                  ))
                }
              />
              <Button
                color="primary"
                startIcon={<Add />}
                onClick={handleAddAnotherClick}
                className="m-t-24"
              >
                Add Invitation
              </Button>
            </div>
            <div className="flex flex-end">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setShowAddContributorModal(false)}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="m-l-24"
                variant="contained"
                color="primary"
              >
                Send invitation(s)
              </Button>
            </div>

            {error && <Message variant="error">{error}</Message>}
          </form>
        )}
      </Formik>
    </>
  )
}

export default ContributorAdd
